import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { deleteBrandLiftSurvey, getBrandLiftRejectReasons } from '../../actions/brandLift';
import {
    CampaignBrandLiftCell,
    CampaignBrandLiftCellProps
} from '../../components/CampaignBrandLiftCell/CampaignBrandLiftCell';
import { selectClientId } from '../../selectors/common';
import { BrandSurveyStatus } from '../../typings/campaigns';
import { ConstData } from '../../typings/constants';
import { CampaignId } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface CampaignBrandLiftCellContainerOwnProps {
    brandSurveyId: string;
    brandSurveyStatus: BrandSurveyStatus;
    constants: ConstData;
    campaignId: CampaignId;
}

export type CampaignBrandLiftCellContainerStateProps = TStateProps<
    CampaignBrandLiftCellProps,
    CampaignBrandLiftCellContainerOwnProps
>;

export type CampaignBrandLiftCellContainerDispatchProps = TDispatchProps<CampaignBrandLiftCellProps>;

const mapStateToProps = (
    state: State,
    ownProps: CampaignBrandLiftCellContainerOwnProps
): CampaignBrandLiftCellContainerStateProps => {
    const clientId = selectClientId(state);
    const { surveysUiUrl, currencyConstants } = ownProps.constants;
    const rejectReasonsText = state.grid.brandLiftRejectReason[ownProps.brandSurveyId];

    let {
        clientInfo: { workCurrency: currency }
    } = state.grid;
    let { brandSurveyBudgetThreshold } = currencyConstants[currency];

    // если brandSurveyBudgetThreshold === 0,
    // то выводим сообщение для рублей, т.к. валют в директе больше, чем кастомных порогов
    if (!brandSurveyBudgetThreshold) {
        currency = CurrencyCode.RUB;
        brandSurveyBudgetThreshold = currencyConstants[currency].brandSurveyBudgetThreshold;
    }

    return {
        clientId,
        surveysUiUrl,
        rejectReasonsText,
        budgetThreshold: brandSurveyBudgetThreshold,
        currency
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): CampaignBrandLiftCellContainerDispatchProps => {
    return {
        getRejectReasonText: (reasonIds: string[], surveyId: string) => {
            dispatch(getBrandLiftRejectReasons(reasonIds, surveyId));
        },
        deleteBrandLiftSurvey: (campaignIds: string[]) => {
            dispatch(deleteBrandLiftSurvey(campaignIds));
        }
    };
};

export const CampaignBrandLiftCellContainer = connect<
    CampaignBrandLiftCellContainerStateProps,
    CampaignBrandLiftCellContainerDispatchProps,
    CampaignBrandLiftCellContainerOwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(CampaignBrandLiftCell);
